import { verify } from './verify';

export const email = {
  verify,
};
